import React, { useEffect, useRef } from 'react'

const GoogleMap = (props) => {
    const mapRef = useRef(null)
    const circleRef = useRef(null)

    useEffect(() => {
        if (!window.google) {
            console.error('Google Maps API not loaded')
            return
        }

        const mapOptions = {
            zoom: props?.zoomLevel || 17,
            center: { lat: parseFloat(props.latitude), lng: parseFloat(props.longitude) },
            fullscreenControl: props?.fullscreenControl || false,
            disableDefaultUI: props?.disableControl || false,
            styles: [
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [{ visibility: 'off' }],
                },
            ],
        }

        try {
            const map = new window.google.maps.Map(mapRef.current, mapOptions)

            if (props?.latitude && props?.longitude) {
                if (props?.locationName) {
                    const marker = new window.google.maps.Marker({
                        position: {
                            lat: parseFloat(props.latitude),
                            lng: parseFloat(props.longitude),
                        },
                        map: map,
                        title: props.locationName,
                    })

                    const infoWindow = new window.google.maps.InfoWindow({
                        content: `<h3>${props.locationName}</h3>`,
                    })

                    marker.addListener('click', () => {
                        infoWindow.open(map, marker)
                    })
                }

                if (props.radius) {
                    if (circleRef.current) {
                        circleRef.current.setMap(null)
                    }

                    const radiusInMeters = parseFloat(props.radius) * 1609.34

                    circleRef.current = new window.google.maps.Circle({
                        strokeColor: '#FF0000',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: '#FF0000',
                        fillOpacity: 0.35,
                        map: map,
                        center: {
                            lat: parseFloat(props.latitude),
                            lng: parseFloat(props.longitude),
                        },
                        radius: radiusInMeters,
                    })

                    map.fitBounds(circleRef.current.getBounds())
                }
            } else if (
                props.multipleLocation &&
                Array.isArray(props.locations) &&
                props.locations.length
            ) {
                const bounds = new window.google.maps.LatLngBounds()

                props.locations.forEach((location) => {
                    const position = new window.google.maps.LatLng(
                        parseFloat(location.latitude),
                        parseFloat(location.longitude),
                    )
                    bounds.extend(position)

                    const marker = new window.google.maps.Marker({
                        position: position,
                        map: map,
                        title: location.name,
                    })

                    const infoWindow = new window.google.maps.InfoWindow({
                        content: `<div><h3>${location.name}</h3><p><a href="${window.location.origin}/search?location=${location.id}" target="_blank">More Info</a></p></div>`,
                    })

                    marker.addListener('click', () => {
                        infoWindow.open(map, marker)
                    })
                })
                map.fitBounds(bounds)

                const listener = window.google.maps.event.addListener(map, 'bounds_changed', () => {
                    if (map.getZoom() > 15) {
                        map.setZoom(15)
                    }
                    window.google.maps.event.removeListener(listener)
                })
            }
        } catch (error) {
            console.error('Error creating map:', error)
        }
    }, [props, props.radius])

    return (
        <div
            ref={mapRef}
            id="map"
            style={{ width: props?.width || '400px', height: props.height || '230px' }}
        ></div>
    )
}

export default GoogleMap
